import { computed, inject } from '@angular/core';
import { UserStore } from '../../store/user/user.store';
import { UserStatus } from '../../model/user-status-info.model';
import { toObservable } from '@angular/core/rxjs-interop';

export class RegistrationWizardStateService {
  userStore = inject(UserStore);
  userStatus = computed(() => this.userStore.userStatusInfo.status());

  isNoAccessExitButtonHidden$ = toObservable(computed(() => this.userStatus() === null || this.userStatus() !== UserStatus.UNKNOWN));

  shouldSkipNoAccess = computed(() => this.userStatus() !== UserStatus.UNKNOWN);

  canEnterTermsOfUse = computed(() =>
    [UserStatus.INVITED, UserStatus.VERIFICATION_PENDING, UserStatus.REGISTRATION_ERROR].includes(this.userStatus()),
  );

  shouldSkipTermsOfUse = computed(() => [UserStatus.VERIFICATION_PENDING, UserStatus.REGISTRATION_ERROR].includes(this.userStatus()));

  canEnterVerification = computed(() => [UserStatus.VERIFICATION_PENDING, UserStatus.REGISTRATION_ERROR].includes(this.userStatus()));

  shouldSkipVerification = this.userStore.isActive;

  canEnterDsgvo = this.userStore.isActive;
}
